var popover = require('bootstrap-sass/assets/javascripts/bootstrap/popover');
var component = require('../../../lib/js/component.js');

function PopoverBtn() {
    var isClickOpen = false;

    this.initialize = function (element, options) {
        var _this = this;

        this.$element = $(element);
        this.$element.attr("aria-expanded", false);

        // Delay required due to Bootstrap popover rendering timing issues,
        // ensures the DOM is fully ready before initializing popover.
        setTimeout(function(){
            initializePopover();
        },500);

        function initializePopover() {
            var placement = _this.$element.attr("data-placement") || "auto";

            _this.$element.popover({
                trigger: "manual", // manually control open/close
                placement: placement,
                delay: { show: 50, hide: 400 },
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-scroll-wrap"><h3 class="popover-title"></h3><div class="popover-content"></div></div></div>'
            });

            setupEventHandlers();
        }

        // Setup hover, click, and keyup event handlers
        function setupEventHandlers() {
            // custom event to close popovers
            $(document).on('closeAllPopovers', function () {
                if (isClickOpen) {
                    closePopover();
                }
            });

            // Hover: Show popover on mouseenter (only if not manually opened by click)
            _this.$element.off("mouseenter.popoverBtn").on("mouseenter.popoverBtn", function () {
                if (!isClickOpen) {
                    _this.$element.popover("show");
                    _this.$element.attr("aria-expanded", true);
                    setupCloseButton();
                }
            });

            // Hover: Hide popover when mouse leaves both button and popover
            _this.$element.off("mouseleave.popoverBtn").on("mouseleave.popoverBtn", function () {
                if (!isClickOpen) {
                    // Small delay to allow user to move from button to popover
                    setTimeout(function () {
                        if (!$(".popover:hover").length && !isClickOpen) {
                            closePopover();
                        }
                    }, 300);
                }
            });

            // Hide popover when mouse leaves actual popover
            $(document).off("mouseleave", ".popover").on("mouseleave", ".popover", function () {
                if (!isClickOpen) {
                    closePopover();
                }
            });

            // Click: Force popover to open and lock it in 'click open' mode
            _this.$element.off("click.popoverBtn").on("click.popoverBtn", function (e) {
                e.preventDefault();
                    if (!isClickOpen) {
                        isClickOpen = true;
                        _this.$element.popover("show");
                        _this.$element.attr("aria-expanded", true);
                        setupCloseButton();

                        if (e.originalEvent.pointerId === -1) {
                            focusPopoverCloseBtn();
                            setupPopoverOnTabEnter();
                        }
                    }
            });

            $(document).off("keyup.popoverBtn").on("keyup.popoverBtn", function (e) {
                if (e.key === "Escape" && isClickOpen) {
                    closePopover();
                }
            });

            _this.$element.off("hidden.bs.popover").on("hidden.bs.popover", function () {
                _this.$element.attr("aria-expanded", false);
            });
        }

        function focusPopoverCloseBtn() {
            var $closeBtn = $(document).find(".popover-close-btn");
            if ($closeBtn.length) {
                $closeBtn.trigger("focus");
            }
        }

        function setupCloseButton() {
            // setTimeout ensures popover DOM is injected before trying to find .popover-close-btn
            setTimeout(function () {
                var $closeBtn = $(document).find(".popover-close-btn");
                if ($closeBtn.length) {
                    $closeBtn.off("click.popoverCloseBtn").on("click.popoverCloseBtn", function (e) {
                        e.preventDefault();
                        closePopover();
                        _this.$element.trigger("focus");
                    });
                }
            }, 100);
        }

        function setupPopoverOnTabEnter() {
            $(document).off("keydown.popoverTab", ".popover").on("keydown.popoverTab", ".popover", function(event) {
                if (event.key === "Tab") { // Check if the pressed key is Tab
                    event.preventDefault(); // Stop the default action
                }
            });
        }

        // Close the popover completely and reset state
        function closePopover() {
            isClickOpen = false;
            _this.$element.popover("hide");
            _this.$element.attr("aria-expanded", false);
            _this.$element.removeData("bs.popover"); 
            $(document).off("keyup.popoverBtn");
            initializePopover();
        }
    };
}
module.exports = component(PopoverBtn);
